import posthog from 'posthog-js';

/**
 * The line our Convex patch (patches/convex@1.47.0.patch, #6530) logs when a
 * realtime frame or an assembled TransitionChunk is not valid JSON. The client
 * drops the partial transition and reconnects; without this report the
 * recovery would be a silent console line.
 */
export const CONVEX_MALFORMED_FRAME_LOG = 'Malformed WebSocket message';
export const CONVEX_MALFORMED_FRAME_CODE = 'CONVEX_REALTIME_MALFORMED_FRAME';

// A flaky network can repeat the reconnect; one report per page is enough.
const MAX_REPORTS_PER_PAGE = 1;
let reportsThisPage = 0;

export function isConvexMalformedFrameLog(args: unknown[]): boolean {
  return args.some(
    (arg) => typeof arg === 'string' && arg.includes(CONVEX_MALFORMED_FRAME_LOG)
  );
}

/**
 * Reports a recovered malformed frame as a handled exception; the browser
 * error policy classifies it as an expected, retryable warning.
 */
export function reportConvexMalformedFrameFromLog(args: unknown[]): boolean {
  if (!isConvexMalformedFrameLog(args)) return false;
  if (typeof window === 'undefined') return false;
  if (reportsThisPage >= MAX_REPORTS_PER_PAGE) return false;
  reportsThisPage += 1;
  posthog.captureException(
    new Error('Convex realtime frame was not valid JSON; reconnected'),
    {
      error_code: CONVEX_MALFORMED_FRAME_CODE,
      error_operation: 'convex_websocket_message',
    }
  );
  return true;
}

export function resetConvexMalformedFrameReportsForTest(): void {
  reportsThisPage = 0;
}
